import { cn } from "../utils";
import isVisible from 'rc-util/lib/Dom/isVisible';
import { composeRef, supportRef } from 'rc-util/lib/ref';
import React, { useRef } from 'react';
import { cloneElement } from "./reactNode";
import useWave from "./useWave";
var Wave = function Wave(props) {
  var children = props.children,
    disabled = props.disabled,
    component = props.component;
  var containerRef = useRef(null);

  // ============================== Style ===============================
  var prefixCls = 'moly-wave';

  // =============================== Wave ===============================
  var showWave = useWave(containerRef, cn(prefixCls), component);

  // ============================== Effect ==============================
  React.useEffect(function () {
    var node = containerRef.current;
    if (!node || node.nodeType !== 1 || disabled) {
      return;
    }

    // Click handler
    var onClick = function onClick(e) {
      // Fix radio button click twice
      if (
      // No need wave
      !isVisible(e.target) || !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('-leave')) {
        return;
      }
      showWave(e);
    };

    // Bind events
    node.addEventListener('click', onClick, true);
    return function () {
      node.removeEventListener('click', onClick, true);
    };
  }, [disabled]);

  // ============================== Render ==============================
  if (! /*#__PURE__*/React.isValidElement(children)) {
    return children !== null && children !== void 0 ? children : null;
  }
  var ref = supportRef(children) ? composeRef(children.ref, containerRef) : containerRef;
  return cloneElement(children, {
    ref: ref
  });
};
if (process.env.NODE_ENV !== 'production') {
  Wave.displayName = 'Wave';
}
export default Wave;